<div class="webinar-container">
  <header class="webinar-header">
    <div class="header-content">
      <div class="header-logo">
        <img src="assets/img/logo.svg" alt="gSignature" class="logo-icon" />
        <span class="logo-text">{{ 'webinar.header.logo' | translate }}</span>
      </div>
      <nav class="header-nav">
        <a (click)="scrollToSection('value', $event)">{{ 'webinar.header.navFor' | translate }}</a>
        <a (click)="scrollToSection('learn', $event)">{{ 'webinar.header.navLearn' | translate }}</a>
        <a (click)="scrollToSection('digitalcard', $event)">{{ 'webinar.header.navDigitalCard' | translate }}</a>
        <a (click)="scrollToSection('backgrounds', $event)">{{ 'webinar.header.navBackgrounds' | translate }}</a>
        <a (click)="scrollToSection('agenda', $event)">{{ 'webinar.header.navAgenda' | translate }}</a>
        <a (click)="scrollToSection('metrics', $event)">{{ 'webinar.header.navMetrics' | translate }}</a>
        <a (click)="scrollToSection('register', $event)">{{ 'webinar.header.navRegister' | translate }}</a>
      </nav>
      <a (click)="scrollToSection('register', $event)" class="header-cta">{{ event.ctaPrimary }}</a>
    </div>
  </header>

  <section class="hero-section">
    <div class="hero-bg-1"></div>
    <div class="hero-bg-2"></div>
    <div class="hero-content">
      <div class="hero-grid">
        <div class="hero-left">
          <h1>{{ event.title }}</h1>
          <p class="hero-subtitle">{{ event.subtitle }}</p>
          
          <div class="hero-badges">
            <span class="badge">
              <i class="fas fa-calendar-alt"></i>
              <span>{{ getFormattedDate() }}</span>
            </span>
            <span class="badge">
              <i class="fas fa-clock"></i>
              <span>{{ event.duration }}</span>
            </span>
            <span class="badge">
              <i class="fas fa-award"></i>
              <span>{{ event.host.name }} • {{ event.host.role }}</span>
            </span>
          </div>

          <div *ngIf="countdown.isActive" class="countdown">
            <div class="countdown-item">
              <div class="countdown-value">{{ countdown.days }}</div>
              <div class="countdown-label">{{ 'webinar.countdown.days' | translate }}</div>
            </div>
            <div class="countdown-item">
              <div class="countdown-value">{{ countdown.hours }}</div>
              <div class="countdown-label">{{ 'webinar.countdown.hours' | translate }}</div>
            </div>
            <div class="countdown-item">
              <div class="countdown-value">{{ countdown.minutes }}</div>
              <div class="countdown-label">{{ 'webinar.countdown.minutes' | translate }}</div>
            </div>
            <div class="countdown-item">
              <div class="countdown-value">{{ countdown.seconds }}</div>
              <div class="countdown-label">{{ 'webinar.countdown.seconds' | translate }}</div>
            </div>
          </div>

          <div class="hero-cta">
            <a (click)="scrollToSection('register', $event)" class="btn-primary">
              {{ event.ctaPrimary }}
              <i class="fas fa-arrow-right"></i>
            </a>
            <a [href]="event.agendaDownloadUrl" [download]="'Webinar_gSignature.pdf'" class="btn-secondary">{{ event.ctaSecondary }}</a>
          </div>

          <p class="hero-description">
            {{ 'webinar.hero.description' | translate }}
          </p>
        </div>

        <div class="hero-right">
          <div class="metrics-card">
            <p class="metrics-title">{{ 'webinar.metrics.title' | translate }}</p>
            <div class="metrics-grid">
              <div *ngFor="let metric of metrics" class="metric-item">
                <div class="metric-label">
                  <i [class]="'fas fa-' + metric.icon"></i>
                  <span>{{ metric.label }}</span>
                </div>
                <div class="metric-value">{{ metric.value }}</div>
              </div>
            </div>
            <ul class="metrics-list">
              <li><i class="far fa-check-circle"></i> {{ 'webinar.metrics.list1' | translate }}</li>
              <li><i class="far fa-check-circle"></i> {{ 'webinar.metrics.list2' | translate }}</li>
              <li><i class="far fa-check-circle"></i> {{ 'webinar.metrics.list3' | translate }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="value" class="section">
    <div class="section-content">
      <h2>{{ 'webinar.value.title' | translate }}</h2>
      <div class="dept-grid">
        <div *ngFor="let dept of deptBenefits" class="dept-card">
          <div class="dept-header">
            <div class="dept-icon-box">
              <i [class]="'fas fa-' + dept.icon"></i>
            </div>
            <p class="dept-title">{{ dept.title }}</p>
          </div>
          <ul class="dept-list">
            <li *ngFor="let point of dept.points">
              <i class="far fa-check-circle"></i>
              <span>{{ point }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section id="learn" class="section">
    <div class="section-content">
      <h2>{{ 'webinar.learn.title' | translate }}</h2>
      <div class="learn-grid">
        <div class="learn-card">
          <h3>{{ 'webinar.learn.trend.title' | translate }}</h3>
          <p>{{ 'webinar.learn.trend.text' | translate }}</p>
        </div>
        <div class="learn-card">
          <h3>{{ 'webinar.learn.operational.title' | translate }}</h3>
          <p>{{ 'webinar.learn.operational.text' | translate }}</p>
        </div>
        <div class="learn-card">
          <h3>{{ 'webinar.learn.roi.title' | translate }}</h3>
          <p>{{ 'webinar.learn.roi.text' | translate }}</p>
        </div>
        <div class="learn-card">
          <h3>{{ 'webinar.learn.templates.title' | translate }}</h3>
          <p>{{ 'webinar.learn.templates.text' | translate }}</p>
        </div>
      </div>
    </div>
  </section>

  <section id="digitalcard" class="section">
    <div class="section-content">
      <h2>{{ 'webinar.digitalCard.title' | translate }}</h2>
      <p class="section-subtitle">{{ 'webinar.digitalCard.subtitle' | translate }}</p>
      <div class="features-grid">
        <div class="feature-card">
          <div class="feature-icon-box">
            <i class="fas fa-qrcode"></i>
          </div>
          <h3>{{ 'webinar.digitalCard.qr.title' | translate }}</h3>
          <p>{{ 'webinar.digitalCard.qr.text' | translate }}</p>
        </div>
        <div class="feature-card">
          <div class="feature-icon-box">
            <i class="fas fa-wallet"></i>
          </div>
          <h3>{{ 'webinar.digitalCard.wallet.title' | translate }}</h3>
          <p>{{ 'webinar.digitalCard.wallet.text' | translate }}</p>
        </div>
        <div class="feature-card">
          <div class="feature-icon-box">
            <i class="fas fa-address-card"></i>
          </div>
          <h3>{{ 'webinar.digitalCard.vcard.title' | translate }}</h3>
          <p>{{ 'webinar.digitalCard.vcard.text' | translate }}</p>
        </div>
        <div class="feature-card">
          <div class="feature-icon-box">
            <i class="fas fa-sync-alt"></i>
          </div>
          <h3>{{ 'webinar.digitalCard.sync.title' | translate }}</h3>
          <p>{{ 'webinar.digitalCard.sync.text' | translate }}</p>
        </div>
      </div>
      <div class="card-benefits">
        <div class="benefit-item">
          <i class="far fa-check-circle"></i>
          <span>{{ 'webinar.digitalCard.benefit1' | translate }}</span>
        </div>
        <div class="benefit-item">
          <i class="far fa-check-circle"></i>
          <span>{{ 'webinar.digitalCard.benefit2' | translate }}</span>
        </div>
        <div class="benefit-item">
          <i class="far fa-check-circle"></i>
          <span>{{ 'webinar.digitalCard.benefit3' | translate }}</span>
        </div>
      </div>
    </div>
  </section>

  <section id="backgrounds" class="section">
    <div class="section-content">
      <h2>{{ 'webinar.backgrounds.title' | translate }}</h2>
      <p class="section-subtitle">{{ 'webinar.backgrounds.subtitle' | translate }}</p>
      <div class="features-grid">
        <div class="feature-card">
          <div class="feature-icon-box branding">
            <i class="fas fa-palette"></i>
          </div>
          <h3>{{ 'webinar.backgrounds.branding.title' | translate }}</h3>
          <p>{{ 'webinar.backgrounds.branding.text' | translate }}</p>
        </div>
        <div class="feature-card">
          <div class="feature-icon-box branding">
            <i class="fas fa-video"></i>
          </div>
          <h3>{{ 'webinar.backgrounds.meetings.title' | translate }}</h3>
          <p>{{ 'webinar.backgrounds.meetings.text' | translate }}</p>
        </div>
        <div class="feature-card">
          <div class="feature-icon-box branding">
            <i class="fas fa-user-tie"></i>
          </div>
          <h3>{{ 'webinar.backgrounds.personal.title' | translate }}</h3>
          <p>{{ 'webinar.backgrounds.personal.text' | translate }}</p>
        </div>
        <div class="feature-card">
          <div class="feature-icon-box branding">
            <i class="fas fa-sliders-h"></i>
          </div>
          <h3>{{ 'webinar.backgrounds.management.title' | translate }}</h3>
          <p>{{ 'webinar.backgrounds.management.text' | translate }}</p>
        </div>
      </div>
      <div class="backgrounds-use-cases">
        <div class="use-case-card">
          <p class="use-case-title">{{ 'webinar.backgrounds.useCases.title' | translate }}</p>
          <ul>
            <li>{{ 'webinar.backgrounds.useCases.case1' | translate }}</li>
            <li>{{ 'webinar.backgrounds.useCases.case2' | translate }}</li>
            <li>{{ 'webinar.backgrounds.useCases.case3' | translate }}</li>
            <li>{{ 'webinar.backgrounds.useCases.case4' | translate }}</li>
          </ul>
        </div>
        <div class="use-case-card">
          <p class="use-case-title">{{ 'webinar.backgrounds.platforms.title' | translate }}</p>
          <ul>
            <li>{{ 'webinar.backgrounds.platforms.platform1' | translate }}</li>
            <li>{{ 'webinar.backgrounds.platforms.platform2' | translate }}</li>
            <li>{{ 'webinar.backgrounds.platforms.platform3' | translate }}</li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section id="agenda" class="section">
    <div class="section-content">
      <h2>{{ 'webinar.agenda.title' | translate }}</h2>
      <div class="agenda-grid">
        <div *ngFor="let item of agendaItems" class="agenda-item">
          <div class="agenda-time">{{ item.t }}</div>
          <div class="agenda-title">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </section>

  <section id="metrics" class="section">
    <div class="section-content">
      <h2>{{ 'webinar.results.title' | translate }}</h2>
      <div class="results-grid">
        <div *ngFor="let metric of metrics" class="result-card">
          <div class="result-label">
            <i [class]="'fas fa-' + metric.icon"></i>
            <span>{{ metric.label }}</span>
          </div>
          <div class="result-value">{{ metric.value }}</div>
        </div>
      </div>
      <div class="results-info-grid">
        <div class="info-card">
          <p class="info-title">{{ 'webinar.results.reportTitle' | translate }}</p>
          <ul>
            <li>{{ 'webinar.results.report1' | translate }}</li>
            <li>{{ 'webinar.results.report2' | translate }}</li>
            <li>{{ 'webinar.results.report3' | translate }}</li>
            <li>{{ 'webinar.results.report4' | translate }}</li>
          </ul>
        </div>
        <div class="info-card">
          <p class="info-title">{{ 'webinar.results.whyTitle' | translate }}</p>
          <ul>
            <li>{{ 'webinar.results.why1' | translate }}</li>
            <li>{{ 'webinar.results.why2' | translate }}</li>
            <li>{{ 'webinar.results.why3' | translate }}</li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section id="register" class="section">
    <div class="section-content">
      <div class="register-grid">
        <div class="register-form-card">
          <h2>{{ 'webinar.register.title' | translate }}</h2>
          <p class="register-subtitle">{{ 'webinar.register.subtitle' | translate }}</p>
          
          <div *ngIf="!submitted" class="register-form-container">
            <form (ngSubmit)="onSubmit($event, form)" #form="ngForm" class="register-form">
              <div class="form-row">
                <div class="form-group">
                  <label>{{ 'webinar.register.form.name' | translate }} <span class="required">*</span></label>
                  <input type="text" name="name" [(ngModel)]="registration.name" required [placeholder]="'webinar.register.form.namePlaceholder' | translate" />
                  <div *ngIf="getFieldError('name')" class="field-error">{{ getFieldError('name') }}</div>
                </div>
                <div class="form-group">
                  <label>{{ 'webinar.register.form.email' | translate }} <span class="required">*</span></label>
                  <input type="email" name="email" [(ngModel)]="registration.email" required [placeholder]="'webinar.register.form.emailPlaceholder' | translate" />
                  <div *ngIf="getFieldError('email')" class="field-error">{{ getFieldError('email') }}</div>
                </div>
              </div>
              
              <div class="form-row">
                <div class="form-group">
                  <label>{{ 'webinar.register.form.company' | translate }} <span class="required">*</span></label>
                  <input type="text" name="company" [(ngModel)]="registration.company" required [placeholder]="'webinar.register.form.companyPlaceholder' | translate" />
                  <div *ngIf="getFieldError('company')" class="field-error">{{ getFieldError('company') }}</div>
                </div>
                <div class="form-group">
                  <label>{{ 'webinar.register.form.role' | translate }} <span class="required">*</span></label>
                  <input type="text" name="role" [(ngModel)]="registration.role" required [placeholder]="'webinar.register.form.rolePlaceholder' | translate" />
                  <div *ngIf="getFieldError('role')" class="field-error">{{ getFieldError('role') }}</div>
                </div>
                <div class="form-group">
                  <label>{{ 'webinar.register.form.phone' | translate }} <span class="required">*</span></label>
                  <input type="tel" name="phone" [(ngModel)]="registration.phone" required [placeholder]="'webinar.register.form.phonePlaceholder' | translate" pattern="^\+?[0-9 ()-]{7,}$" />
                  <div *ngIf="getFieldError('phone')" class="field-error">{{ getFieldError('phone') }}</div>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group">
                  <label>{{ 'webinar.register.form.teamSize' | translate }}<span class="required">*</span></label>
                  <select name="team_size" [(ngModel)]="registration.team_size" required>
                    <option value="">{{ 'webinar.register.form.select' | translate }}</option>
                    <option value="1-10">{{ 'webinar.register.form.team1' | translate }}</option>
                    <option value="11-50">{{ 'webinar.register.form.team2' | translate }}</option>
                    <option value="51-200">{{ 'webinar.register.form.team3' | translate }}</option>
                    <option value=">200">{{ 'webinar.register.form.team4' | translate }}</option>
                  </select>
                  <div *ngIf="getFieldError('team_size')" class="field-error">{{ getFieldError('team_size') }}</div>
                </div>
                <div class="form-group">
                  <label>{{ 'webinar.register.form.stack' | translate }} <span class="required">*</span></label>
                  <select name="stack" [(ngModel)]="registration.stack" required>
                    <option value="">{{ 'webinar.register.form.select' | translate }}</option>
                    <option>{{ 'webinar.register.form.stackGoogle' | translate }}</option>
                    <option>{{ 'webinar.register.form.stackMicrosoft' | translate }}</option>
                    <option>{{ 'webinar.register.form.stackHybrid' | translate }}</option>
                    <option>{{ 'webinar.register.form.stackUnknown' | translate }}</option>
                  </select>
                  <div *ngIf="getFieldError('stack')" class="field-error">{{ getFieldError('stack') }}</div>
                </div>
              </div>

              <div class="bonus-box">
                <p class="bonus-title">{{ 'webinar.register.form.bonusTitle' | translate }}</p>
                <p>{{ 'webinar.register.form.bonusText' | translate }}</p>
              </div>

              <div class="checkbox-group">
                <label class="checkbox-label">
                  <input type="checkbox" name="consent" [(ngModel)]="registration.consent" required />
                  <span>{{ 'webinar.register.form.consent' | translate }}</span>
                </label>
              </div>

              <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>

              <button type="submit" class="btn-submit" [disabled]="isSubmitting">
                {{ isSubmitting ? ('webinar.register.form.submitting' | translate) : event.ctaPrimary }}
                <i class="fas fa-arrow-right"></i>
              </button>
              
              <p class="form-disclaimer">
                {{ 'webinar.register.form.disclaimer' | translate }}
              </p>
            </form>
          </div>

          <div *ngIf="submitted" class="success-message">
            <p class="success-title">{{ 'webinar.register.success.title' | translate }}</p>
            <p>{{ 'webinar.register.success.message' | translate }}</p>
          </div>
        </div>

        <div class="register-sidebar">
          <div class="host-card">
            <h3>{{ 'webinar.host.title' | translate }}</h3>
            <div class="host-info">
              <img src="assets/img/pedro.png" alt="{{ event.host.name }}" class="host-avatar" />
              <div>
                <p class="host-name">{{ event.host.name }}</p>
                <p class="host-role">{{ event.host.role }}</p>
              </div>
            </div>
            <ul class="host-list">
              <li><i class="far fa-check-circle"></i> {{ 'webinar.host.point1' | translate }}</li>
              <li><i class="far fa-check-circle"></i> {{ 'webinar.host.point2' | translate }}</li>
              <li><i class="far fa-check-circle"></i> {{ 'webinar.host.point3' | translate }}</li>
            </ul>
          </div>

          <div class="faq-card">
            <h3>{{ 'webinar.faq.title' | translate }}</h3>
            <ul class="faq-list">
              <li>
                <p class="faq-question">{{ 'webinar.faq.q1' | translate }}</p>
                <p>{{ 'webinar.faq.a1' | translate }}</p>
              </li>
              <li>
                <p class="faq-question">{{ 'webinar.faq.q2' | translate }}</p>
                <p>{{ 'webinar.faq.a2' | translate }}</p>
              </li>
              <li>
                <p class="faq-question">{{ 'webinar.faq.q3' | translate }}</p>
                <p>{{ 'webinar.faq.a3' | translate }}</p>
              </li>
              <li>
                <p class="faq-question">{{ 'webinar.faq.q4' | translate }}</p>
                <p>{{ 'webinar.faq.a4' | translate }}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="final-cta">
    <div class="final-cta-content">
      <div>
        <p class="final-cta-title">{{ 'webinar.finalCta.title' | translate }}</p>
        <p>{{ 'webinar.finalCta.text' | translate }}</p>
      </div>
      <a (click)="scrollToSection('register', $event)" class="btn-secondary">
        {{ event.ctaPrimary }}
        <i class="fas fa-arrow-right"></i>
      </a>
    </div>
  </section>

  <footer class="webinar-footer">
    <p>{{ 'webinar.footer.company' | translate: {year: currentYear} }}</p>
    <p>{{ 'webinar.footer.keywords' | translate }}</p>
  </footer>
</div>
